import React from 'react';
import propTypes from "prop-types";
import s from "./textarea.module.css";
export function Textarea(_a) {
    var className = _a.className, label = _a.label, leadIcon = _a.leadIcon, tailIcon = _a.tailIcon, value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, disabled = _a.disabled, error = _a.error;
    return (React.createElement("div", { className: "".concat(s.container, " ").concat(className || '', " ").concat(disabled ? s.disabled : '', " ").concat(error ? s.inputError : '') },
        label && React.createElement("span", { className: s.label }, label),
        React.createElement("div", { className: s.field },
            leadIcon || null,
            React.createElement("textarea", { className: s.textarea, placeholder: placeholder, value: value, onChange: onChange, disabled: disabled }),
            tailIcon || null),
        typeof error === 'string' && error &&
            (React.createElement("span", { className: s.error }, error))));
}
Textarea.propTypes = {
    className: propTypes.string,
    placeholder: propTypes.string,
    value: propTypes.string,
    label: propTypes.string,
    leadIcon: propTypes.node,
    tailIcon: propTypes.node,
    disabled: propTypes.bool,
    onChange: propTypes.func,
    error: propTypes.oneOfType([
        propTypes.string,
        propTypes.bool,
    ]),
};
//# sourceMappingURL=Textarea.js.map